export const Logo = ({ onLight = false }) => (
  <span data-testid="brand-logo" className="relative inline-flex select-none flex-col pt-2">
    <svg viewBox="0 0 160 22" className="absolute -top-0.5 left-1 h-[18px] w-[150px]" aria-hidden="true">
      <defs>
        <linearGradient id="swoosh" x1="0" x2="1">
          <stop offset="0" stopColor="#2F7BFF" stopOpacity="0" />
          <stop offset=".35" stopColor="#2F7BFF" />
          <stop offset="1" stopColor="#7FB2FF" />
        </linearGradient>
      </defs>
      <path d="M2 18 C 40 2, 100 -2, 158 8 C 110 4, 60 8, 2 18 Z" fill="url(#swoosh)" />
    </svg>
    <span className={`font-display text-[26px] font-extrabold italic leading-none tracking-tight ${onLight ? "text-[#0B1224]" : "text-white"}`}>
      Autovantis
    </span>
  </span>
);
